import React, { useEffect } from 'react'
import { useRouter } from '@core'

import { css } from 'src/ui/style/css'
import { Theme } from 'src/ui/style/Theme'
import { CtaButton } from 'src/app/CtaButton'
import { headerDimension } from 'src/layout/header/Header'
import { useTran } from 'src/i18n/useTran'
import { msg } from 'src/i18n/texts/keys'
import {
    isInOrderingProcess,
    orderingPages
} from 'src/business/ordering/orderingPages'
import { useOrderValue } from 'src/business/ordering/order/useOrder'
import { BoxOrder } from 'src/business/ordering/order/BoxOrder'
import { mediaMaxWidth } from 'src/ui/style/mixins/helpers'
import { useRouterLocation } from 'src/lib/useRouterLocation'
import { useSearchParams } from 'src/app/useSearchParams'
import { isAndroidNativeApp, isIosNativeApp } from 'src/geo/locationService'
import { getAppContext } from 'src/context/AppContext'

const pickOrderingPath = (order: BoxOrder): string => {
    if (!order.invoicing) return orderingPages.OrderOffer.to()

    if (!order.invoicingDetailsValid) return orderingPages.OrderUserDetails.to()

    return orderingPages.OrderSummary.to()
}

// eslint-disable-next-line @typescript-eslint/no-var-requires,@typescript-eslint/no-require-imports
const routes = require('src/routing/routes').default

export const ReturnToOrderButton = () => {
    // disable button
    return null

    // eslint-disable-next-line
    const t = useTran()

    const limitedView = useSearchParams().get('limitedView') === 'true'

    const isNativeApp =
        (isIosNativeApp() || isAndroidNativeApp()) &&
        location.pathname === routes.landingWebview.path

    if (limitedView || isNativeApp) return null

    const l = useRouterLocation()
    const orderValue = useOrderValue()
    const { order } = getAppContext()
    const r = useRouter()

    const THREE_DAYS = 3 * 24 * 60 * 60 * 1000
    const created = orderValue?.createdAt
        ? new Date(orderValue?.createdAt)?.getTime()
        : undefined

    const isExpired =
        created !== undefined && Date.now() - created >= THREE_DAYS

    useEffect(() => {
        if (isExpired) {
            order.store.clear()
        }
    }, [isExpired])

    if (
        !orderValue ||
        isExpired ||
        isInOrderingProcess(l) ||
        l?.path === routes.landing.path ||
        l?.path === routes.landingWebview.path
    )
        return null

    const doReturn = () => {
        r.push(pickOrderingPath(orderValue))
    }

    return (
        <CtaButton
            id="return-to-order-button"
            onClick={doReturn}
            css={(th: Theme) => css`
                // Fixed position to the bottom left of the screen
                position: fixed;
                bottom: ${th.spacing.lg};
                left: ${th.spacing.lg};
                z-index: ${headerDimension.zIndex - 3};
                box-shadow: ${th.boxShadow.bottomOnly};
                // On mobile, stick to the bottom of screen and stretch to total width

                ${mediaMaxWidth(th.screens.sm)} {
                    position: sticky;
                    bottom: ${th.spacing.sm};
                    left: ${th.spacing.sm};
                    box-shadow: ${th.boxShadow.bottomOnly};
                }
            `}
        >
            {t(msg.ui.returnToOrder)}
        </CtaButton>
    )
}
